import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c4-four-two-one',
  templateUrl: './c4-four-two-one.component.html',
  styleUrls: ['./c4-four-two-one.component.scss']
})
export class C4FourTwoOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
